import { render, staticRenderFns } from "./imgLoad.vue?vue&type=template&id=e2c88b6c&"
import script from "./imgLoad.vue?vue&type=script&lang=js&"
export * from "./imgLoad.vue?vue&type=script&lang=js&"
import style0 from "./imgLoad.vue?vue&type=style&index=0&id=e2c88b6c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports